import {
    AssetLink,
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
    EntryLink,
} from './contracts';
import {
    LandingPageSection,
    isLandingPageSectionContent,
} from './TypeLandingPageSection';
import {
    LandingPageSection3Column,
    isLandingPageSection3ColumnContent,
} from './TypeLandingPageSection3Column';

export interface LandingPageContentFields
    extends ContentfulEntryContractFields {
    headerBackgroundImage?: AssetLink;
    introHeader?: string;
    introText?: string;
    sections?: EntryLink[];
    urlName?: string;
    youtubeVideoImage?: AssetLink;
    youtubeVideoUrl?: string;
}

export type LandingPageContract = ContentfulEntryContract<
    LandingPageContentFields,
    'landingPage'
>;

export type LandingPageContent =
    ContentfulEntryFromContract<LandingPageContract>;

export class LandingPage {
    private contract: Partial<LandingPageContent>;

    constructor(contract: Partial<LandingPageContent> = {}) {
        this.contract = contract;
    }

    get headerBackgroundImageUrl(): string {
        return (
            this.contract.fields?.headerBackgroundImage?.fields.file?.url ?? ''
        );
    }

    get introHeader(): string {
        return this.contract.fields?.introHeader ?? '';
    }

    get introText(): string {
        return this.contract.fields?.introText ?? '';
    }

    get sections(): (LandingPageSection | LandingPageSection3Column)[] {
        return (this.contract.fields?.sections ?? []).reduce<
            (LandingPageSection | LandingPageSection3Column)[]
        >((sections, section) => {
            if (isLandingPageSection3ColumnContent(section)) {
                sections.push(new LandingPageSection3Column(section));
            } else if (isLandingPageSectionContent(section)) {
                sections.push(new LandingPageSection(section));
            }
            return sections;
        }, []);
    }

    get urlName(): string {
        return this.contract.fields?.urlName ?? '';
    }

    get youtubeVideoImageUrl(): string {
        return this.contract.fields?.youtubeVideoImage?.fields.file?.url ?? '';
    }

    get youtubeVideoUrl(): string {
        return this.contract.fields?.youtubeVideoUrl ?? '';
    }
}
